<template>
  <div class="blocks">
    <div class="top">设备负荷</div>
    <div class="blossomVideo">
      <div class="echarts14" id="echarts14"></div>
      <div class="bottom">
          <div class="zhixingtime">
            待执行时间:
            <span class="toperform">{{echarts14Data.UnExcuteTime}}hrs</span>
          </div>
          <!-- <div class="tixing"></div> -->
          <div class="zhixingtime bgno">
            已执行时间:
           <span class="executetime">{{echarts14Data.ExcutedTime}}hrs</span>
          </div>
          <div class="sumtask">
            总执行任务:
            <span>{{echarts14Data.ExcutedCount+echarts14Data.UnExcuteCount}}个</span>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
//这是设备维保当前状态组件
export default {
  name: "echarts13",
  props: {
    echarts14Data: {
      type: Object,
      default: () => {
        return {
          EquipmentNo: "SC03",
          UnExcuteCount: 150,
          UnExcuteTime: 10,
          ExcutedCount: 50,
          ExcutedTime: 1.3
        };
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.pies();
  },
  methods: {
    pies() {
      var _this = this;
      var becharts14 = this.$echarts.init(document.getElementById("echarts14"));
      var placeHolderStyle = {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          color: "rgba(0,0,0,0)",
          borderWidth: 0
        },
        emphasis: {
          color: "#243255",
          borderWidth: 0
        }
      };

      var dataStyle = {
        normal: {
          formatter: "{c}%",
          position: "center",
          show: true,
          textStyle: {
            fontSize: "24",
            fontWeight: "normal",
            color: "#fff"
          }
        }
      };
       let sum =
        _this.echarts14Data.UnExcuteCount + _this.echarts14Data.ExcutedCount;
      var option = {
        //    backgroundColor: "#EF1D22",
        series: [
          {
            name: "统计",
            type: "gauge",
            clockWise: true, //顺时加载
            startAngle: 230,
            endAngle: -50,
            radius: "100%", //图表尺寸
            center: ["60%", "55%"],
            axisLine: {
              show: true,
              lineStyle: {
                width: 5,
                shadowBlur: 0,
                color: [[1, "#CBEEE4"]]
              }
            },
            axisTick: {
              show: false,
              lineStyle: {
                color: "auto",
                width: 2
              },
              length: -20,
              splitNumber: 5
            },
            splitLine: {
              show: false,
              length: -30,
              lineStyle: {
                color: "auto",
                width: 2
              }
            },
            axisLabel: {
              show: false
            },
            pointer: {
              //仪表盘指针
              show: false
            },
             detail: {
              show: true,
              offsetCenter: [0, "-30%"], // x, y，单位px
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: "#01D2D2",
                fontSize: 12
              },
              formatter: "已执行"
            },
            title: {
              show: false
              //    textStyle: {
              //      color: '#fff',
              //      fontSize: 14
              //    }
            },
            data: []
          },
          {
            type: "gauge",
            radius: "90%",
            center: ["60%", "55%"],
            splitNumber: 0, //刻度数量
            startAngle: 230,
            endAngle: -50,
            axisLine: {
              show: true,
              lineStyle: {
                width: 14,
                color: [
                  [
                    _this.echarts14Data.UnExcuteCount / sum,
                    new _this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: "#144156"
                      },
                      {
                        offset: 1,
                        color: "#0FDCED"
                      }
                    ])
                  ],
                  [
                    1,
                    new _this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: "#153750"
                      },
                      {
                        offset: 1,
                        color: "#153750"
                      }
                    ])
                  ]
                ]
              }
            },
            //分隔线样式。
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: true
            },
            pointer: {
              show: false
            },
            title: {
              show: true,
              offsetCenter: [0, "-30%"], // x, y，单位px
              textStyle: {
                color: "#000",
                fontSize: 16
              }
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              offsetCenter: [0, "16%"],
              color: "#05BA83",
              clockWise: true,
              formatter: function(params) {
                // console.log(params);
                return params;
              },
              textStyle: {
                fontSize: 42
              }
            },
            data:[
              {
                value: _this.echarts14Data.UnExcuteCount,
                itemStyle: {
                  normal: {
                    color: new _this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: "#F5340C"
                        },
                        {
                          offset: 1,
                          color: "#0E152E"
                        }
                      ]
                    )
                  }
                },
                label: dataStyle
              },
              {
                value: _this.echarts14Data.ExcutedCount,
                itemStyle: placeHolderStyle
              }
            ]
          }
        ]
      };
      // var num1 = 0,
      //   num2 = 0;
      // var myInterval = setInterval(function() {
      //   num1 += Math.round(Math.random()) === 0 ? 0.011 : 0.005;
      //   num2 += Math.round(Math.random()) === 0 ? 0.011 : 0.005;
      //   if (num1 >= 1) num1 = 0;
      //   if (num2 >= 1) num2 = 0;
      //   option.series[1].axisLine.lineStyle.color = [
      //     [
      //       num1,
      //       new _this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
      //         {
      //           offset: 0,
      //           color: "#0D6243"
      //         },
      //         {
      //           offset: 0.8,
      //           color: "#67EAC4"
      //         },
      //         {
      //           offset: 1,
      //           color: "#9CFFD7"
      //         }
      //       ])
      //     ],
      //     [1, "#88D1BC"]
      //   ];
        becharts14.setOption(option);
      // }, 30);
      // var mytimeout = setTimeout(function() {
      //   clearTimeout(myInterval);
      // }, 2300);
    }
  }
};
</script>
<style  scoped>
.blocks {
  width: 100%;
  height: 100%;
  /* width: 318px;
  height: 118px; */
  /* background: url("../../assets/imgs/title-bg.png") no-repeat;
  background-size: 100% 100%; */
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.top {
  position: absolute;
  left: 0;
  top: 0;
  width: 150px;
  height: 32px;
  color: #A9925C;
  text-align: center;
  line-height: 32px;
  font-size: 22px;
  font-weight: bold;
}
.blossomVideo {
  width: 410px;
  height: 170px;
  position: relative;
  border-radius: 6px;
}
.echarts14 {
  width: 230px;
  height: 100%;
}
.bottom {
  position: absolute;
  /* width: 105px; */
  height: 170px;
  bottom: 0px;
  right: 0;
  margin-left: 3px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
/* div.bottom:nth-child(2) {
  left: 118px;
}
div.bottom:nth-child(3) {
  left: 228px;
}
div.bottom:nth-child(4) {
  left: 338px;
} */
.zhixingtime {
  color: #000;
  /* width: 120px; */
  height: 22px;
  margin-top: 5px;
  text-align: left;
  padding-left: 10px;
  font-size: 16px;
  /* background: url("../../assets/imgs/tixing.png") no-repeat;
  background-size: 100% 100%; */
}
.toperform {
  font-size: 20px;
  color: #ECA424;
}
.yitime {
  margin-top: 15px;
  font-size: 12px;
  color: #379ac3;
}
.executetime {
  font-size: 20px;
  color: #00E3B4;
}
.sumtask {
  width: 120px;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  background-color: #9F8545;
  color: #fff;
  text-align: left;
  padding-left: 10px
}
.sumtask span {
  color: #fff;
  font-size: 20px;
  
}
.bgno {
    background: none;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts10.vue